import React from "react";

import {
  businessName,
} from "./invoiceTemplate.shared";

import "./InvoiceBrandAssets.css";


export const getBusinessInitials =
  (
    business
  ) => {

    const name =
      String(
        businessName(
          business
        ) ||
        ""
      )
        .replace(
          /[^a-zA-Z0-9\s]/g,
          " "
        )
        .replace(
          /\s+/g,
          " "
        )
        .trim();


    if (
      !name
    ) {

      return "BU";

    }


    /*
    |--------------------------------------------------------------------------
    | REQUESTED COMKWIK FALLBACK
    |--------------------------------------------------------------------------
    |
    | ComKwik Computers -> CM
    | ComKwik Computer  -> CM
    | ComKwik Infotech  -> CM
    |
    |--------------------------------------------------------------------------
    */

    if (
      /^comkwik\s+(computers?|infotech)\b/i.test(
        name
      )
    ) {

      return "CM";

    }


    const words =
      name
        .split(
          " "
        )
        .filter(
          Boolean
        );


    if (
      words.length >=
      2
    ) {

      return (
        `${words[0][0] || ""}${words[1][0] || ""}`
          .toUpperCase() ||
        "BU"
      );

    }


    return (
      (
        words[0] ||
        name
      )
        .slice(
          0,
          2
        )
        .toUpperCase() ||
      "BU"
    );

  };


export const resolveBusinessLogo =
  (
    business
  ) =>
    String(
      business
        ?.invoiceBranding
        ?.logo ||

      business?.logo ||

      business
        ?.branding
        ?.logo ||

      ""
    ).trim();


export const resolveInvoiceSignature =
  (
    business
  ) => {

    const branding =
      business
        ?.invoiceBranding ||
      {};


    const rawMode =
      String(
        branding
          ?.signatureMode ||
        business
          ?.signatureMode ||
        ""
      )
        .trim()
        .toUpperCase();


    const image =
      String(
        branding
          ?.signatureImage ||

        business
          ?.signature ||

        business
          ?.authorizedSignature ||

        ""
      ).trim();


    const text =
      String(
        branding
          ?.signatureText ||

        business
          ?.signatureText ||

        ""
      ).trim();


    const style =
      String(
        branding
          ?.signatureStyle ||

        business
          ?.signatureStyle ||

        "STYLE_1"
      )
        .trim()
        .toUpperCase();


    const mode =
      rawMode ||
      (
        image
          ?
          "UPLOAD"
          :
          (
            text
              ?
              "TEXT"
              :
              "NONE"
          )
      );


    return {
      mode,
      image,
      text,
      style,
    };

  };


export const InvoiceBrandMark =
  ({
    businessSnapshot,
    compact = false,
    className = "",
  }) => {

    const logo =
      resolveBusinessLogo(
        businessSnapshot
      );


    return (

      <div
        className={[
          "invoice-brand-mark",
          compact
            ?
            "invoice-brand-mark--compact"
            :
            "",
          className,
        ]
          .filter(
            Boolean
          )
          .join(
            " "
          )}
      >

        {
          logo
            ?
            (
              <img
                src={
                  logo
                }

                alt={`${businessName(
                  businessSnapshot
                )} logo`}
              />
            )
            :
            (
              <span>

                {
                  getBusinessInitials(
                    businessSnapshot
                  )
                }

              </span>
            )
        }

      </div>

    );

  };


export const InvoiceSignature =
  ({
    businessSnapshot,
    showLabel = true,
    className = "",
  }) => {

    const {
      mode,
      image,
      text,
      style,
    } =
      resolveInvoiceSignature(
        businessSnapshot
      );


    const hasImage =
      (
        mode ===
        "UPLOAD" ||
        mode ===
        "DRAW"
      ) &&
      Boolean(
        image
      );


    const hasText =
      mode ===
      "TEXT" &&
      Boolean(
        text
      );


    if (
      !hasImage &&
      !hasText
    ) {

      return (
        showLabel
          ?
          (
            <div
              className={[
                "invoice-template-signature",
                "invoice-template-signature--empty",
                className,
              ]
                .filter(
                  Boolean
                )
                .join(
                  " "
                )}
            >
              <strong>
                Authorized Signatory
              </strong>
            </div>
          )
          :
          null
      );

    }


    return (

      <div
        className={[
          "invoice-template-signature",
          className,
        ]
          .filter(
            Boolean
          )
          .join(
            " "
          )}
      >

        {
          hasImage &&
          (
            <img
              src={
                image
              }

              alt="Authorized Signature"
            />
          )
        }


        {
          hasText &&
          (
            <div
              className={[
                "invoice-template-signature__text",
                `invoice-template-signature__text--${style.toLowerCase()}`,
              ].join(
                " "
              )}
            >
              {text}
            </div>
          )
        }


        {
          showLabel &&
          (
            <strong>
              Authorized Signatory
            </strong>
          )
        }

      </div>

    );

  };
